import { useQuery } from 'react-query';

import { IPaging, IQueryParameters } from 'common/models';
import { QUERY_KEYS } from 'consts/queryKeys';
import { getCalculationLogs } from 'modules/accommodations/features/reservations/api';

interface IProps extends IPaging, IQueryParameters {
  isEnabled: boolean;
}

export const useQueryReservationLogs = (reservationId: string, options?: IProps) => {
  const { params, pageNo = 1, pageSize = 100, isEnabled = true } = options || {};

  return useQuery(
    [QUERY_KEYS.RENTALS_CALCULATION_LOGS, reservationId, pageNo, pageSize, params],
    () =>
      getCalculationLogs(reservationId, {
        params,
        pageSize,
        pageNo,
      }),
    {
      enabled: isEnabled,
    },
  );
};
